export const alias = {
  maiden: {
    help: {
      title: 'Need help with the maiden name question?',
      message:
        'Select "Yes" if this was your surname used from birth before it was legally changed at marriage.',
      note: '',
    },
  },
  reason: {
    help: {
      title: 'Need help with the explanation?',
      message: 'We want to understand why this other name was used and/or changed.',
      note: 'Examples: Nickname used since birth, changed when married, pen name. ',
    },
  },
  used: {
    help: {
      title: 'Need help with the dates used range?',
      message:
        'This date range is for the full time period you used the name or were known by it.',
      note:
        'Example: If the name was used from your birth until the present use your birthdate for "From" and select "Present"',
    },
  },
};
